module.exports = __webpack_public_path__ + "static/media/mode-534.b800e1b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-534.svg
// module id = 1070
// module chunks = 2